module.exports = __webpack_public_path__ + "static/media/53_A.8b70598c.png";